import { render, staticRenderFns } from "./ConvidarAmigos.vue?vue&type=template&id=e3354bd6&scoped=true&"
import script from "./ConvidarAmigos.vue?vue&type=script&lang=js&"
export * from "./ConvidarAmigos.vue?vue&type=script&lang=js&"
import style0 from "./ConvidarAmigos.vue?vue&type=style&index=0&id=e3354bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3354bd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VContainer,VDivider,VIcon,VTextField})
